import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash/fp/isNil';
import { MobileHeaderModal } from './MobileHeaderModal';
import modulePropTypes from './modulePropTypes';
export var MobileAppMenu = function MobileAppMenu(props) {
  var appMenuItems = props.appMenuItems,
    appNavigator = props.appNavigator,
    showHomeIcon = props.showHomeIcon,
    homeRoute = props.homeRoute,
    onToggleAppMenu = props.onToggleAppMenu;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShown = _useState2[0],
    setIsShown = _useState2[1];
  var handleToggleNavigation = function handleToggleNavigation() {
    var newState = !isShown;
    setIsShown(newState);
    onToggleAppMenu(newState);
  };
  var hasAppContent = !(isNil(appMenuItems) && isNil(appNavigator));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "navbar-header min-width-50 padding-5 overflow-hidden position-relative display-flex align-items-center",
    onClick: handleToggleNavigation
  }, /*#__PURE__*/React.createElement("span", {
    className: "navbar-brand height-40 width-40 ".concat(showHomeIcon ? 'home-icon' : '')
  }, !hasAppContent && homeRoute), hasAppContent && /*#__PURE__*/React.createElement("div", {
    className: "position-absolute right-2 bottom-0 text-color-white rotate-45"
  }, /*#__PURE__*/React.createElement("span", {
    className: "rioglyph rioglyph-triangle-right"
  }))), appNavigator && /*#__PURE__*/React.createElement(MobileHeaderModal, {
    show: isShown,
    modalClassName: "padding-top-25",
    onClose: handleToggleNavigation
  }, /*#__PURE__*/React.createElement("div", {
    className: "width-100pct height-100pct"
  }, appNavigator)), appMenuItems && /*#__PURE__*/React.createElement(MobileHeaderModal, {
    show: isShown,
    modalClassName: "padding-15",
    onClose: handleToggleNavigation
  }, appMenuItems.map(function (module) {
    return /*#__PURE__*/React.createElement("li", {
      role: "presentation",
      key: "link-icon-".concat(module.key)
    }, module.route);
  })));
};
MobileAppMenu.propTypes = {
  homeRoute: PropTypes.node,
  showHomeIcon: PropTypes.bool,
  appMenuItems: PropTypes.arrayOf(modulePropTypes),
  appNavigator: PropTypes.element,
  onToggleAppMenu: PropTypes.func
};